export default __webpack_public_path__ + "static/media/bdt_logo.ac1ad306.svg";